module.exports = __webpack_public_path__ + "img/article-icon-104.3475a9f1.svg";